import { motion } from 'framer-motion'
import dynamic from 'next/dynamic'
import { useState } from 'react'
import s from './MemoryGallery.module.scss'

const GallerySlider = dynamic(() => import('../gallerySlider/GallerySlider'), {
    ssr: false,
})

const Gallery = dynamic(() => import('../gallery/Gallery'), {
    ssr: false,
})

type Props = {
    gallery: Array<string>
}

function MemoryGallery({ gallery }: Props) {
    const [showGallery, setShowGallery] = useState(false)
    const [index, setIndex] = useState(0)

    return (
        <>
            {showGallery && (
                <Gallery
                    gallery={gallery}
                    index={index}
                    showModal={showGallery}
                    setShowModal={setShowGallery}
                />
            )}
            {gallery?.length > 0 && (
                <motion.div className={s.gallery} layout>
                    <GallerySlider
                        style="memory"
                        gallery={gallery}
                        setShowModal={setShowGallery}
                        setIndex={setIndex}
                    />
                </motion.div>
            )}
        </>
    )
}

export default MemoryGallery
